import React, { useState } from 'react';
import MainLayout from '../../components/mainLayOut/MainLayout';
import { Link } from 'react-router-dom';

const OurPrograms = () => {
  const [playingVideo, setPlayingVideo] = useState(null);
  
  // Your YouTube videos
  const programVideos = [
    "https://www.youtube.com/embed/LyvPJz-84V8",
    "https://www.youtube.com/embed/ANGld_Flxwc",
    "https://www.youtube.com/embed/Pzr6t5DYBy8",
    "https://www.youtube.com/embed/Oa_VByzu53g"
  ];

  const programs = [
    {
      title: "Little Einsteins (5-7 years)",
      description: "Foundational program that introduces abacus concepts through games and interactive activities",
      duration: "6 months",
      benefits: ["Number recognition", "Basic arithmetic", "Fine motor skills"],
      image: "https://images.unsplash.com/photo-1590005024862-6b67679a29fb?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      video: programVideos[0]
    },
    {
      title: "Math Masters (8-12 years)",
      description: "Comprehensive program that develops lightning-fast mental calculation abilities",
      duration: "12 months",
      benefits: ["Mental arithmetic", "Improved concentration", "Enhanced memory"],
      image: "https://images.unsplash.com/photo-1588072432904-843af37f03ed?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      video: programVideos[1]
    },
    {
      title: "Brain Champions (13+ years)",
      description: "Advanced program for competition preparation and cognitive enhancement",
      duration: "18 months",
      benefits: ["Competition techniques", "Advanced mental math", "Cognitive development"],
      image: "https://images.unsplash.com/photo-1588072432836-e10032774350?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      video: programVideos[2]
    },
    {
      title: "Brain Gym",
      description: "Supplemental program to enhance overall cognitive abilities and learning skills",
      duration: "Ongoing",
      benefits: ["Improved focus", "Better memory", "Enhanced learning ability"],
      image: "https://images.unsplash.com/photo-1588072432904-843af37f03ed?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
      video: programVideos[3]
    }
  ];

  const handleVideoPlay = (index) => {
    setPlayingVideo(playingVideo === index ? null : index);
  };

  // Dummy student pictures for success stories
  const studentPics = [
    "https://randomuser.me/api/portraits/men/32.jpg",
    "https://randomuser.me/api/portraits/women/44.jpg",
    "https://randomuser.me/api/portraits/men/22.jpg",
    "https://randomuser.me/api/portraits/women/63.jpg"
  ];

  return (
    <MainLayout>
      <div className="">
        {/* Hero Section */}
        <div className="text-center mb-16 bg-gradient-to-r from-blue-600 to-purple-600 text-white py-16 md:py-20">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Our Transformative Programs</h1>
          <p className="text-xl max-w-3xl mx-auto">
            Designed by experts to unlock your child's full potential through our unique blend of abacus training and cognitive development
          </p>
        </div>

        {/* Programs Grid */}
        <div className="grid md:grid-cols-2 gap-10 mb-20 px-2">
          {programs.map((program, index) => (
            <div key={index} className="bg-white rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow">
              <div className="relative">
                <img 
                  src={program.image} 
                  alt={program.title} 
                  className="w-full h-48 object-cover"
                />
                <div className="absolute bottom-0 left-0 bg-blue-600 text-white px-4 py-2 rounded-tr-lg font-medium">
                  {program.duration} Program
                </div>
              </div>
              <div className="p-6">
                <h2 className="text-2xl font-bold text-gray-800 mb-3">{program.title}</h2>
                <p className="text-gray-600 mb-4">{program.description}</p>
                
                <h3 className="font-semibold text-gray-800 mb-2">Key Benefits:</h3>
                <ul className="mb-6">
                  {program.benefits.map((benefit, i) => (
                    <li key={i} className="flex items-center mb-2">
                      <svg className="w-5 h-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                      {benefit}
                    </li>
                  ))}
                </ul>
                
                <div className="aspect-w-16 aspect-h-9 mb-4">
                  {playingVideo === index ? (
                    <div className="relative w-full h-72 rounded-lg overflow-hidden">
                      <iframe 
                        src={`${program.video}?autoplay=1&rel=0&mute=1`}
                        className="absolute top-0 left-0 w-full h-full"
                        title={`${program.title} Demo`}
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : (
                    <div 
                      className="relative w-full h-72 rounded-lg bg-gray-200 cursor-pointer group"
                      onClick={() => handleVideoPlay(index)}
                    >
                      <img 
                        src={program.image} 
                        alt={program.title} 
                        className="w-full h-full object-cover rounded-lg"
                      />
                      <div className="absolute inset-0 bg-black/30 rounded-lg flex items-center justify-center transition-opacity group-hover:bg-black/40">
                        <div className="w-16 h-16 bg-white/90 rounded-full flex items-center justify-center transform transition-transform group-hover:scale-110">
                          <svg className="w-8 h-8 text-blue-600" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M8 5v14l11-7z" />
                          </svg>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                
                <Link 
                  to="/register" 
                  className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg transition duration-300 text-center"
                >
                  Enroll Now
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* Success Stories */}
        <div className="mx-2 bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 md:p-12 text-white mb-20">
          <h2 className="text-3xl font-bold mb-8 text-center">Success Stories From Our Students</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white/10 p-6 rounded-xl">
              <div className="flex items-center mb-4">
                <img 
                  src={studentPics[0]} 
                  alt="Student" 
                  className="w-12 h-12 rounded-full mr-3"
                />
                <div>
                  <h3 className="font-bold">Rahul Sharma</h3>
                  <p className="text-blue-200">National Champion 2023</p>
                </div>
              </div>
              <p>"I went from struggling with math to winning national competitions in just 18 months!"</p>
            </div>
            <div className="bg-white/10 p-6 rounded-xl">
              <div className="flex items-center mb-4">
                <img 
                  src={studentPics[1]} 
                  alt="Student" 
                  className="w-12 h-12 rounded-full mr-3"
                />
                <div>
                  <h3 className="font-bold">Priya Patel</h3>
                  <p className="text-blue-200">State Topper</p>
                </div>
              </div>
              <p>"The Brain Gym program helped me focus better in all my subjects, not just math."</p>
            </div>
            <div className="bg-white/10 p-6 rounded-xl">
              <div className="flex items-center mb-4">
                <img 
                  src={studentPics[2]} 
                  alt="Parent" 
                  className="w-12 h-12 rounded-full mr-3"
                />
                <div>
                  <h3 className="font-bold">Aditya Rao</h3>
                  <p className="text-blue-200">Parent</p>
                </div>
              </div>
              <p>"My son's confidence has skyrocketed since joining Ascent Abacus. Highly recommended!"</p>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="text-center mb-4">
          <h2 className="text-3xl font-bold text-gray-800 mb-6">Ready to Transform Your Child's Learning?</h2>
          <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
            Join our next batch starting soon. Limited seats available!
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link 
              to="/contact" 
              className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full transition-all shadow-lg hover:shadow-xl"
            >
              Book Free Demo
            </Link>
            <a 
              href="https://www.facebook.com/ascentabacusbraingym" 
              target="_blank" 
              rel="noopener noreferrer"
              className="bg-white border-2 border-blue-600 text-blue-600 hover:bg-blue-50 font-bold py-3 px-8 rounded-full transition-all shadow-lg hover:shadow-xl flex items-center"
            >
              <svg className="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 24 24">
                <path d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" />
              </svg>
              Message Us
            </a>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default OurPrograms;